import React from "react";
import { FooterContainer } from "./style";
import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <Row>
          <Col sm={12} md={9}>
            <section className="footer-contact">
              <h6>ارتباط با ما</h6>
              <div className="text">
                تلفن تماس : 48491000-021
                <br />
                فکس : 44504660 – 021
                <br />
                آدرس : کیلومتر 9 جاده مخصوص کرج، خیابان نخ زرین، پلاک 21
              </div>
            </section>
          </Col>
          <Col sm={12} md={3}>
            <section className="copyright">
              <img className={'logo'} src="/images/fotter_logo.png" alt="Arian Motor" />
              {/*<a href={'https://trustseal.enamad.ir/?id=210209&code=E50vconVOOKhTQ4VN5gq'} target={'_blank'}>*/}
              {/*  <img src="/images/enamad.png" />*/}
              {/*</a>*/}
            </section>
          </Col>
        </Row>
      </Container>
    </FooterContainer>
  );
};
export default Footer;
